import React, { useState } from "react";

import Copywriter from "./Copywriter";
import { CopywriterProvider } from "./CopywriterContext";

const App = ({ children, ...props }) => {

  return (
    <CopywriterProvider {...props}>
      <Copywriter>
        {children}
      </Copywriter>
    </CopywriterProvider>
  );
};

export default App;
